import React, { useMemo } from 'react'
import { BoxCon, BoxScoreBottomRow, GameCon } from '../styles'
import {
  timeStampToDate,
  getPeriodAndClockTime,
  ClockTime,
} from '../../../Utils'
import type { EventGQL } from '../../../Api'
import { BoxScoreAction } from './BoxScoreAction'
import { BoxScoreInfo } from './BoxScoreInfo'
import { GeneralTeamRow } from './Teams/GeneralTeamRow'
import { BoxScoreTeam } from './Teams/BoxScoreTeam'
import { TeamScore } from './Teams/TeamScore'
import { BoxScoreStatus } from './BoxScoreStatus'
import { Broadcasters } from './Broadcast/Broadcasters'
import { useLiveGameContext } from '../../../Context'

type EventProps = {
  eventData: EventGQL
  teamId?: string
}

export const EventBox: React.FC<React.PropsWithChildren<EventProps>> = ({
  eventData,
}) => {
  const { liveGameEvent } = useLiveGameContext()
  const awayTeam = eventData?.awayTeam
  const homeTeam = eventData?.homeTeam
  
  const date = useMemo(() => {
    return timeStampToDate(eventData?.startTime)?.date ?? ''
  }, [eventData])

  const clockTime = useMemo((): ClockTime | undefined => {
    if(!liveGameEvent || liveGameEvent.id !== eventData.id) return 
      const periodAndTime = getPeriodAndClockTime(liveGameEvent)
      return periodAndTime
  }, [liveGameEvent])

  if (!eventData) {
    return <div />
  }

  return (
    <BoxCon>
      <BoxScoreInfo event={eventData} date={date} />
      <GameCon>
        <div className="teamsAndScoresCol">
          <div className="teamAndScoreRow">
            <>
              {!awayTeam?.officialId ? (
                <GeneralTeamRow />
              ) : (
                <BoxScoreTeam team={awayTeam} event={eventData} />
              )}
            </>
            {eventData?.eventStatus >= 1 && <TeamScore event={eventData} teamStatus="away" />}
          </div>

          <div className="teamAndScoreRow">
            <>
              {!homeTeam?.officialId ? (
                <GeneralTeamRow />
              ) : (
                <BoxScoreTeam team={homeTeam} event={eventData} />
              )}
            </>
            {eventData?.eventStatus >= 1 && <TeamScore event={eventData} teamStatus="home" />}
          </div>
        </div>
        <BoxScoreStatus
          event={eventData}
          period={clockTime?.period}
          clockTime={clockTime?.clockTime}
        />
      </GameCon>
      <BoxScoreBottomRow>
        <Broadcasters event={eventData} />
        <BoxScoreAction event={eventData} buttonText="View Stats" />
        <BoxScoreAction event={eventData} buttonText="Preview" />
      </BoxScoreBottomRow>
    </BoxCon>
  )
}
